exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pa-7-responsivePortrait{padding:2rem}.pa-7-responsiveLandscape{padding:1rem}", ""]);

// exports
